import { GTMEvent } from '~/lib/gtm/GTM'

export const adaptLogin = () => {
  return {
    event: GTMEvent.LOGIN,
  }
}
